import api from './api';

export const codesService = {
  // Get all IR codes with pagination (for dashboard)
  getAllCodes: async (params = {}) => {
    const response = await api.get('/api/ir-codes/all', { params });
    return response.data;
  },

  // Get IR codes by model code
  getCodes: async (params = {}) => {
    const response = await api.get('/api/ir-codes/', { params });
    return response.data;
  },

  // Get single IR code
  getCode: async (id) => {
    const response = await api.get(`/api/ir-codes/${id}`);
    return response.data;
  },

  // Create new IR code
  createCode: async (codeData) => {
    const response = await api.post('/api/ir-codes/', codeData);
    return response.data;
  },

  // Update IR code
  updateCode: async (id, codeData) => {
    const response = await api.put(`/api/ir-codes/${id}`, codeData);
    return response.data;
  },

  // Delete IR code
  deleteCode: async (id) => {
    const response = await api.delete(`/api/ir-codes/${id}`);
    return response.data;
  },

  // Upload IR codes via CSV
  uploadCSV: async (file, modelCode) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('model_code', modelCode);
    
    const response = await api.post('/api/import-export/import/csv', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Export IR codes as CSV
  exportCSV: async (modelCode) => {
    const response = await api.get('/api/import-export/export/csv', {
      params: { model_code: modelCode },
      responseType: 'blob',
    });
    return response.data;
  },

  // Search IR codes across models
  searchCodes: async (params = {}) => {
    const response = await api.get('/api/ir-codes/search', { params });
    return response.data;
  },
};
